// Libs
import classNames from 'classnames/bind';
import { Outlet } from 'react-router-dom';
import { Alert, Text, View } from '@instructure/ui';
// Components, Layouts, Pages
import { Header } from '~/layouts/main/components';
// Others
import packageJson from '../../../package.json';
import { useAppDispatch, useAppSelector } from '~/utils/redux/hooks';
import { toastActions } from '~/thunks/toast/toastSlice';
// Styles, images, icons
import styles from './Main.module.scss';

const cx = classNames.bind(styles);

const Main = () => {
  //#region Destructuring Props
  //#endregion Destructuring Props

  //#region Declare Hook
  const dispatch = useAppDispatch();
  //#endregion Declare Hook

  //#region Selector
  const toasts = useAppSelector((state) => state.toastState.toasts);
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleDismissAlert = (messageId: string) => {
    dispatch(toastActions.removeToast(messageId));
  };
  //#endregion Handle Function

  return (
    <div id='mainLayout' className={cx('container')}>
      <header className={cx('header')}>
        <Header />
      </header>

      <main className={cx('content')}>
        <section className={cx('mainContent')}>
          <Outlet />
        </section>
      </main>

      <div className={cx('versionText')}>
        <Text variant='contentSmall'>{packageJson.version}</Text>
      </div>

      <View className={cx('containerAlert')}>
        {toasts.map((toast, index) => {
          return (
            <Alert
              key={index}
              variant={toast.type}
              renderCloseButtonLabel={toast.allowClose && 'Close'}
              open={true}
              margin='small 0'
              onDismiss={() => handleDismissAlert(toast.id)}
            >
              {toast.message}
            </Alert>
          );
        })}
      </View>
    </div>
  );
};

export default Main;
